module.exports = __webpack_public_path__ + "img/get.0f0bc910.svg";